import React, { useEffect, useRef, useState } from 'react'
import { Button, Checkbox, message, Tooltip, Image, Typography } from 'antd'
import _, { isArray } from 'lodash'
import styles from './index.module.less'
import SkuDynamicContent from '../SkuDynamicContent'
const { Paragraph } = Typography
const KitDetailContent = ({
  disabled = false,
  kitList = [], //必选项
  noMustChooseList = [], // 可选项
  setMustChooseList = () => ({}),
  setNoMustChooseList = () => ({}),
  formatCombinationData = () => ({}),
}: any) => {
  // 动态属性
  const [skuDynamicOpen, setSkuDynamicOpen] = useState(false) // 动态属性弹窗
  const [skuDynamicVoList, setSkuDynamicVoList] = useState<any>([]) // 报价属性表单数据
  const [currentIndex, setCurrentIndex] = useState<number>(0) // 当前修改数组索引
  const [kitListType, setKitListType] = useState<string>('') // 当前修改类型
  const tagsMap = {
    NATIONAL_UPPLEMENT: 'nationalCss',
  }

  const changeChecked = (id: string, item: any, attr: any, isMust: boolean) => {
    if (disabled) {
      return
    }
    if (attr.disabled) {
      return
    }
    const list = isMust ? kitList : noMustChooseList
    const newList = list?.map((kit: any) => {
      if (kit.id === id) {
        const newDynamicList = kit.useArgList?.map((dynamicItem: any) => {
          if (dynamicItem.argCode === item.argCode) {
            const newList = dynamicItem?.list?.map((value: any) => {
              if (value.valueId === attr.valueId) {
                return {
                  ...value,
                  isActive: !value.isActive,
                  disabled: false,
                }
              }
              return {
                ...value,
                isActive: false,
                disabled: false,
              }
            })
            return {
              ...dynamicItem,
              list: newList,
            }
          } else {
            const newList = dynamicItem?.list?.map((value: any) => {
              return {
                ...value,
                disabled: false,
              }
            })
            return {
              ...dynamicItem,
              list: newList,
            }
          }
        })
        return {
          ...kit,
          useArgList: newDynamicList,
        }
      }
      return {
        ...kit,
      }
    })

    let newUseArgList: any = []
    let skuList: any = []
    /**
     * 找出选中的规格
     */
    const chooseArgMap: any = {}
    newList.forEach((item: any) => {
      if (item.id === id) {
        newUseArgList = _.cloneDeep(item.useArgList)
        skuList = _.cloneDeep(item.selectedSkuList)
        item.useArgList?.forEach((arg: any) => {
          if (arg?.list?.length) {
            arg?.list?.forEach((value: any) => {
              if (value.isActive) {
                chooseArgMap[arg.argCode] = value.valueId
              }
            })
          }
        })
      }
    })

    const cloneMap = _.cloneDeep(chooseArgMap)
    Object.keys(cloneMap)?.forEach((argCode: any) => {
      const useArgMap: any = {} // 所有用过的规格和值
      // 遍历过程中会改变chooseArgMap的值，可能出现不存在的情况
      if (!chooseArgMap?.[argCode]) {
        return
      }
      // 等于当前规格值的sku
      skuList
        .filter((sku: any) => sku?.argMap?.[argCode]?.valueId === chooseArgMap?.[argCode])
        ?.forEach((sku: any) => {
          const keys = Object.keys(sku?.argMap)
          keys.forEach(key => {
            // 正在选择的规格不能置灰
            if (key === argCode) {
              return
            }
            if (useArgMap[key]?.length) {
              if (!useArgMap[key].includes(sku?.argMap[key]?.valueId)) {
                useArgMap[key].push(sku?.argMap[key]?.valueId)
              }
            } else {
              useArgMap[key] = [sku?.argMap[key]?.valueId]
            }
          })
        })
      /**
       * 根据useArgMap处理规格的置灰逻辑， 如果之前已经选过的值被置灰，要把选择态取消并且从chooseArgMap中移除，避免后续继续筛选
       */
      newUseArgList = newUseArgList.map((arg: any) => {
        if (useArgMap[arg.argCode]?.length) {
          const newList = arg.list?.map((item: any) => {
            if (useArgMap[arg.argCode].includes(item.valueId)) {
              return {
                ...item,
                disabled: false,
              }
            } else {
              // 等于表明之前选中过，这个时候置灰就必须把之前选中的值去掉
              chooseArgMap[arg.argCode] =
                chooseArgMap[arg.argCode] === item.valueId ? '' : chooseArgMap[arg.argCode]
              return {
                ...item,
                isActive: false,
                disabled: true,
              }
            }
          })
          return {
            ...arg,
            list: newList,
          }
        }
        return {
          ...arg,
        }
      })
    })

    const formatList = newList.map((item: any) => {
      if (item.id === id) {
        return {
          ...item,
          useArgList: newUseArgList,
        }
      }
      return {
        ...item,
      }
    })
    if (isMust) {
      formatCombinationData(formatList, noMustChooseList, true, id)
    } else {
      formatCombinationData(kitList, formatList, true, id)
    }
  }

  // 单个选材勾选
  const singleMaterialCheck = (e: any, index: any) => {
    const newData = _.cloneDeep(noMustChooseList)
    newData[index].checked = e.target.checked
    formatCombinationData(kitList, newData, true)
  }
  // 修改动态属性
  const handleEditSkuDynamicVoList = async (record: any, index: number, type: string) => {
    setCurrentIndex(index)
    setKitListType(type)
    console.log(record)
    if (record.materialDynaOptions && record.materialDynaOptions.length) {
      setSkuDynamicOpen(true)
      setSkuDynamicVoList(record.materialDynaOptions)
    } else {
      setSkuDynamicOpen(true)
      // 调用接口获取报价属性值
      setSkuDynamicVoList(record.skuDynamicVoList)
    }
  }
  const onSubmitSkuDynamicVoList = async (value, kit) => {
    console.log(value, 'value')
    if (value?.filter((item: any) => item.optionId).length !== kit.skuDynamicVoList?.length) return
    // 所有选项选完才更新
    const newData = kit.required ? _.cloneDeep(kitList) : _.cloneDeep(noMustChooseList)
    let currentIndex = newData.findIndex((item: any) => item.id === kit.id)
    newData[currentIndex].materialDynaOptions = value
    if (kit.required) {
      setMustChooseList(newData)
    } else {
      setNoMustChooseList(newData)
    }
  }
  const showNationalTagRender = (kit: any) => {
    // // 当确定skuid后 显示国补
    let showTags = kit?.skuList?.find((sku: any) => sku.id === kit?.selectSkuId)?.showTags
    if (showTags && isArray(showTags)) {
      return showTags?.map((tag: any) => {
        return (
          <div className={tagsMap[tag.tagCode]}>
            <Tooltip placement="topLeft" title={tag.tagName}>
              {tag.tagName}
            </Tooltip>
          </div>
        )
      })
    } else {
      return <></>
    }
  }
  const dynaOptionRender = (kit: any) => {
    console.log(kit, 'kit')
    // 只有一个sku的时候只展示规格内容
    if (kit.skuList?.length === 1) {
      let argMap = kit.skuList[0]?.argMap
      let str = ''
      Object?.keys(argMap)?.forEach((key: any) => {
        str += argMap[key]?.argName + '：' + argMap[key]?.valueName + '；'
      })
      return str
    }
  }
  const dialogContent = () => {
    return (
      <>
        <div className={styles.KitDetailDialogBox}>
          {kitList &&
            kitList?.length !== 0 &&
            kitList.map((kit: any, index: any) => {
              if (kit.allowView) {
                return (
                  <>
                    <div className={styles.orderDetail} key={'kit' + index}>
                      <div className={styles.orderDetailInfoBox}>
                        <div className={styles.imgBox}>
                          <Image.PreviewGroup items={kit?.product?.imageUrls || undefined}>
                            <Image src={kit?.mainPicUrl} className={styles.img} />
                          </Image.PreviewGroup>
                        </div>
                        <div className={styles.orderDetailInfo}>
                          <div className={styles.infoTitle}>
                            <div className={styles.descTitle}>
                              {showNationalTagRender(kit)}
                              <Tooltip title={kit?.prodName} placement="topLeft">
                                <p> {kit?.prodName}</p>
                              </Tooltip>
                            </div>
                          </div>
                          <div className={styles.kitId}>
                            <span style={{marginRight: '4px'}}>SPU: </span> 
                            <Paragraph copyable>{kit.id}</Paragraph>
                          </div>
                          <div className={styles.footInfo}>
                            {kit.skuList?.length === 1 && dynaOptionRender(kit)&& (
                              <div className={styles.houseInfo}>
                                <div>规格：{dynaOptionRender(kit)}</div>
                              </div>
                            )}
                          </div>
                          <div className={styles.footInfo}>
                            {kit.product?.brandName && (
                              <div className={styles.houseInfo}>
                                <div>品牌：{kit.product?.brandName}</div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {kit?.useArgList &&
                        kit?.useArgList?.length !== 0 &&
                        kit?.useArgList?.map((item: any, itemIndex: number) => {
                          return kit?.allowView ? (
                            <div key={'kitItem' + itemIndex}>
                              <div className={styles.chooseTitle}>
                                <span className={styles.mustChoose}>*</span>
                                <span className={styles.titleFont}>{item?.argName}</span>
                              </div>
                              <div className={styles.chooseList}>
                                {item?.list &&
                                  item?.list?.length !== 0 &&
                                  item?.list?.map((attr: any, attrIndex: number) => (
                                    <div
                                      key={'kitItemAttr' + attrIndex}
                                      className={`${styles.item} ${
                                        attr.isActive ? styles.itemActive : ''
                                      } ${attr.disabled ? styles.disabled : ''}`}
                                      onClick={() => {
                                        changeChecked(kit.id, item, attr, true)
                                      }}
                                    >
                                      <span className={`${styles.radio} ${''}`}></span>
                                      <div>{attr.valueName}</div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          ) : null
                        })}
                      {/* 动态属性 */}
                      <SkuDynamicContent
                        loading={false}
                        formList={
                          kit?.materialDynaOptions
                            ? kit?.materialDynaOptions
                            : kit?.skuDynamicVoList
                        }
                        onSubmit={onSubmitSkuDynamicVoList}
                        currentItem={kit}
                      ></SkuDynamicContent>
                    </div>
                  </>
                )
              }
            })}
        </div>
        {noMustChooseList?.length ? (
          <>
            <div className={styles.classTitle}>可选项</div>
            <div className={styles.KitDetailDialogBox}>
              {noMustChooseList &&
                noMustChooseList?.length !== 0 &&
                noMustChooseList.map((kit: any, index: any) => {
                  if (kit.allowView) {
                    return (
                      <>
                        <div className={styles.orderDetail} key={'kit' + index}>
                          <div className={styles.orderDetailInfoBox}>
                            <div style={{ display: 'flex' }}>
                              <Checkbox
                                checked={kit.checked}
                                defaultChecked={kit.checked}
                                onChange={(e: any) => {
                                  singleMaterialCheck(e, index)
                                }}
                              ></Checkbox>
                            </div>
                            <div className={styles.imgBox}>
                              <Image.PreviewGroup items={kit?.product?.imageUrls || undefined}>
                                <Image src={kit?.mainPicUrl} className={styles.img} />
                              </Image.PreviewGroup>
                            </div>
                            <div className={styles.orderDetailInfo}>
                              <div className={styles.infoTitle}>
                                <div className={styles.descTitle}>
                                  {showNationalTagRender(kit)}
                                  <Tooltip title={kit?.prodName} placement="topLeft">
                                    <span> {kit?.prodName}</span>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className={styles.kitId}>
                                 <span style={{marginRight: '4px'}}>SPU: </span> 
                                <Paragraph copyable>{kit.id}</Paragraph>
                              </div>
                              <div className={styles.footInfo}>
                                {kit.skuList?.length === 1 && dynaOptionRender(kit)&& (
                                  <div className={styles.houseInfo}>
                                    <div>规格：{dynaOptionRender(kit)}</div>
                                  </div>
                                )}
                              </div>
                              <div className={styles.footInfo}>
                                {kit.product?.brandName && (
                                  <div className={styles.houseInfo}>
                                    <div>品牌：{kit.product?.brandName}</div>
                                  </div>
                                )}
                              </div>
                            </div>
                            {
                              <>
                                {/* {
                                <div className={styles.detailButton}>
                                  {kit.skuDynamicVoList?.length ? (
                                    <Button
                                      onClick={() =>
                                        handleEditSkuDynamicVoList(kit, index, 'noMust')
                                      }
                                    >
                                      报价属性
                                    </Button>
                                  ) : null}
                                </div>
                              } */}
                              </>
                            }
                          </div>
                          {kit?.useArgList &&
                            kit?.useArgList?.length !== 0 &&
                            kit?.useArgList?.map((item: any, itemIndex: number) => {
                              return (
                                <div key={'kitItem' + itemIndex}>
                                  <div className={styles.chooseTitle}>
                                    <span className={styles.mustChoose}>*</span>
                                    <span className={styles.titleFont}>{item?.argName}</span>
                                  </div>
                                  <div className={styles.chooseList}>
                                    {item?.list &&
                                      item?.list?.length !== 0 &&
                                      item?.list?.map((attr: any, attrIndex: number) => (
                                        <div
                                          key={'kitItemAttr' + attrIndex}
                                          className={`${styles.item} ${
                                            attr.isActive ? styles.itemActive : ''
                                          } ${attr.disabled ? styles.disabled : ''}`}
                                          onClick={() => {
                                            changeChecked(kit.id, item, attr, false)
                                          }}
                                        >
                                          <span className={`${styles.radio} ${''}`}></span>
                                          <div>{attr.valueName}</div>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              )
                            })}
                          {/* 动态属性 */}
                          <SkuDynamicContent
                            loading={false}
                            formList={
                              kit?.materialDynaOptions
                                ? kit?.materialDynaOptions
                                : kit?.skuDynamicVoList
                            }
                            onSubmit={onSubmitSkuDynamicVoList}
                            currentItem={kit}
                          ></SkuDynamicContent>
                        </div>
                      </>
                    )
                  }
                })}
            </div>
          </>
        ) : null}
      </>
    )
  }

  return <div className={styles.KitDetailDialog}>{dialogContent()}</div>
}

export default KitDetailContent
